/* LEGAL-NOTICE
   © Copyright 2018 - Quid Informatica S.p.A. - All Rights Reserved
   https://quidinfo.it/qinetic/licence.html - "Quid Consumer Lending Platform"
   Deposito SIAE n. 012702 del 26 Luglio 2018
LEGAL-NOTICE */
import { Injectable } from '@angular/core';
import { DTOMappers } from '@models/generic/dto-mappers.model';
import {
  PositionDTO,
  WizardDTO,
  SurveyDTO,
  FormDTO,
  ChecklistDTO,
  UserDataDTO,
  NoteDTO,
  ChannelDTO
} from '@api/models';

@Injectable({
  providedIn: 'root'
})
export class ApiResParserService implements DTOMappers {
  generic<T>(res: any): T {
    return res;
  }

  userData(res: any): UserDataDTO {
    return res;
  }

  position(res: any): PositionDTO {
    return res;
  }

  wizard(res: any): WizardDTO {
    return res;
  }

  surveys(res: any): SurveyDTO[] {
    return res;
  }

  forms(res: any): FormDTO[] {
    return res;
  }

  checklist(res: any): ChecklistDTO {
    return res;
  }

  notes(res: any): NoteDTO[] {
    return res;
  }

  channel(res: any): ChannelDTO {
    return res;
  }

  protected cleanPayload<T>(res: any): T {
    if (!!res && !!res.payload) {
      return res.payload;
    } else {
      return res;
    }
  }
}
